// 该文档为官网国际化语言-英文
const en = {
  setting:{
    languageType:'English',
    serviceHotline:'Hotline',
    officialWechat:'Wechat',
    companyName:'Fleetan Digital Logistics Technology Co., Ltd',
    companyCopyrightText:'2020-2023 Fleetan Digital Logistics Technology Co., Ltd Copyright reserved',
    companyAddress:'6E, Building D, Galaxy World, No. 1 Yabao Road, Wuhe Avenue, Longhua District, Shenzhen, China',
    companyNews:'Company News',
    companyProfile:'We are a full-service provider of cross-border logistics in the Middle East (Saudi Arabia/UAE), offering a comprehensive range of first-leg services including air transportation, sea transportation for LCL/FCL, and import customs clearance. We are committed to leveraging technology to enhance logistics operations. Through our self-developed digital logistics management system and leveraging the internet, we enable real-time tracking and operation of goods. With our self-operated overseas warehouses in Saudi Arabia and the UAE, we provide diversified services to accelerate cargo circulation, offering efficient, stable, and secure logistics experiences to Middle East cross-border merchants, empowering them to explore business opportunities in the Middle East.'
  },
  // 顶部菜单
  topItem:{
    home:'Home',
    serviceItem:{
      title:'Service',
      serviceOne:'FBA/FBN Dedicated Line',
      serviceTwo:'Air/Sea Door-to-Door',
      serviceThree:'Overseas warehouse',
      serviceFour:'Sea FCL Customs Clearance',
      serviceFive:'Saber certificate',
      serviceSix:'B2C Dedicated Line for Small Packages',
    },
    tracking:'Tracking',
    news:'News',
    aboutUsItem:{
      title:'About Us',
      contentOne:'Company Profile',
      contentTwo:'Development History',
      contentThree:'Cooperative Partners',
      contentFour:'Contact Us',
    },
    login:'Login',
  },
  // 滚动横幅
  bannerItem:{
    itemOne:{
      text:'To Middle East, Choose',
      subText:'Fleetan',
      lastText:'',
      contentOne:{
        text:'Fleetan Digital Logistics',
        subText:'',
        lastText:'',
      }
    },
    itemTwo:{
      text:'Amazon SPN ISP',
      subText:'',
      lastText:'',
      contentOne:{
        text:'Middle East Full Link Service Provider',
        subText:'',
        lastText:'',
      }
    },
    itemThree:{
      text:'Air freight efficiency',
      subText:'5-7',
      lastText:'days',
      contentOne:{
        text:'Sea freight efficiency',
        subText:'35',
        lastText:'days',
      }
    },
    itemFour:{
      text:'Self-operated overseas warehouse',
      subText:'Fleetan',
      lastText:'',
      contentOne:{
        text:'FBA/FBN Warehouse Transfer',
        subText:'',
        lastText:'',
      },
      contentTwo:{
        text:'Dropshipping',
        subText:'',
        lastText:'',
      },
      contentThree:{
        text:'Carton stock/Sorting',
        subText:'',
        lastText:'',
      },
      contentFour:{
        text:'Secondary delivery to warehouse',
        subText:'',
        lastText:'',
      },
      contentFive:{
        text:'RTO',
        subText:'',
        lastText:'',
      }
    },
    itemFive:{
      text:'Independently developed system',
      subText:'',
      lastText:'',
      contentOne:{
        text:'Visualization of inventory',
        subText:'',
        lastText:'',
      },
      contentTwo:{
        text:'Transparency of logistics trajectory',
        subText:'',
        lastText:'',
      },
      contentThree:{
        text:'Electronic issuance of instructions',
        subText:'',
        lastText:'',
      },
    },

  },
  // 核心业务
  mainServiceItem:{
    titlePartOne:'Main',
    titlePartTwo:' Service',
    serviceOne:{
      title:'Middle East FBA/FBN Dedicated Line',
      contentOne:'air freight: 5-7 days, sea freight: about 35 days',
      contentTwo:'FBA free appointment delivery, high success rate of FBN delivery',
      detailOne:{
        content:'Middle East FBA/FBN Dedicated Line, Stable channels and guaranteed timeliness'
      },
      detailTwo:{
        content:'Amazon SPN Service Provider, FBA delivery without appointment'
      },
      detailThree:{
        content:'Rich experience in NOON delivery, high success rate for FBN delivery'
      }
    },
    serviceTwo:{
      title:'Door-to-Door Air and Sea Freight',
      contentOne:'Provide a complete set of logistics services including local consignee, customs declaration, clearance, SABER certificate, local delivery, and payment collection in the Middle East',
      detailOne:{
        title:'To SA Air Transportation Timeliness：',
        content:'5-7 days'
      },
      detailTwo:{
        title:'To SA Sea Transportation Timeliness：',
        content:'35-40 days'
      },
      detailThree:{
        title:'To UAE Air Transportation Timeliness：',
        content:'8-12 days'
      },
      detailFour:{
        title:'To UAE Sea Transportation Timeliness：',
        content:'28-35 days'
      },
    },
    serviceThree:{
      title:'Overseas warehouse',
      contentOne:'Self-operated warehouse(SA/UAE)',
      contentTwo:'Provide comprehensive services such as FBA/FBN temporary storage and transportation, one piece shipping, return and label exchange, etc',
      detailOne:{
        title:'Middle East Network：',
        content:'Self-operated overseas warehouses in Saudi Arabia/UAE'
      },
      detailTwo:{
        title:'Leading Scale：',
        content:'Covering an area of nearly 10,000 square meters, capable of accommodating over 1,200 standard pallets, with more than 10,000 e-commerce storage locations'
      },
      detailThree:{
        title:'Compliance and Safety：',
        content:"Fully compliant certification for overseas warehouses, legally employed labor, ensuring the safety and security of customer goods"
      },
      detailFour:{
        title:'Service Content：',
        content:'Providing a comprehensive range of services including FBA/FBN temporary storage and transshipment, one-piece consignment, return and label replacement, etc'
      },
    },
    serviceFour:{
      title:'Sea Full container customs clearance',
      contentOne:'Our own customs clearance agency',
      contentTwo:'Rich experience in certificate customs clearance, providing multiple customs clearance solutions',
      detailOne:{
        content:'We have our own customs brokerage, providing multiple customs clearance solutions'
      },
      detailTwo:{
        content:'Professional customs clearance team with extensive experience in certificate customs clearance'
      },
    },
    serviceFive:{
      title:'Saber certificate',
      contentOne:'Saber registration, quick registration',
      contentTwo:'SC can issue the certificate on the same day',
      detailOne:{
        content:'Extensive experience in certificate customs clearance, Quickly match products and corresponding certificates'
      },
      detailTwo:{
        content:'Fast issuance speed, SC can issue certificates on the same day'
      },
    },
    serviceSix:{
      title:'B2C Dedicated Line for Small Packages',
      contentOne:'Own overseas warehouse+mature local delivery team, high delivery rate, fast delivery time, providing COD solutions',
      detailOne:{
        content:'High sign-for rate, fast delivery time'
      },
      detailTwo:{
        content:'Self-operated overseas warehouse + mature local delivery team'
      },
      detailThree:{
        content:'Providing COD (Cash on Delivery) solutions'
      },
    },
  },
  // 服务优势
  serviceAdvantageItem:{
    titlePartOne:'Service',
    titlePartTwo:' Advantage',
    countData:{
      titleOne:'Number of partners',
      titleTwo:'Number of customers served',
      titleThree:'Storage area',
      titleFour:'Average signing rate',
    },
    adOne:{
      title:'Technology and system',
      content:'Our developed digital system <strong>enables the interception of high-risk orders, dynamic switching of logistics routes, real-time cross-border payment collection, and other value-added services.</strong> It optimizes the entire logistics chain, improves logistics efficiency, strengthens cargo safety supervision, and reduces logistics costs',
    },
    adTwo:{
      title:'Wide value-added full empowerment',
      content:'With the help of big data analysis, regularly output service tracking feedback, empower customers in reverse, help improve delivery rates, and provide comprehensive basis for customer decision-making',
    },
    adThree:{
      title:'Stable channel and fast delivery time',
      content:'First hand resources, stable position, <strong>empty delivery time of 5-7 days, FBA/FBN full delivery time of 8-10 days (including warehouse delivery)</strong>',
    },
    adFour:{
      title:'High professional and fast certification',
      content:'We have our own customs clearance channels and a professional customs clearance team, providing Middle Eastern consignees and a complete set of logistics solutions. We have SABER registration and fast issuance of certificates, and SC can issue certificates on the same day',
    },
    adFive:{
      title:'High delivery and fast payment collection',
      content:'Self built overseas warehouse, self owned local delivery team, <strong>high COD delivery rate, weekly payment collection,</strong> accelerated capital turnover, and reduced capital risk',
    },
    adSix:{
      title:'Safety concerns and secure',
      content:'Pay attention to the safety of goods, track logistics trajectories in real-time through digital systems, and ensure that every link is traceable',
    },
  },
  // 轨迹追踪
  trackingItem:{
    title:'Tracking',
    search:'Search',
    searching:'Searching',
    searchTips:'Please input Fleetan order no. to search trajectory',
    inputTips:'Please input Fleetan order no first',
    orderNo:'OrderNo',
    noResultTips:'Unable to retrieve trajectory information',
    noTrackingTips:'No Data',
    searchError:'Error，Please contact the customer service for consultation',
    batch:'Batch',
    batchInfo:'Batch Info',
    appointmentTime:'Appointment Time',
  },

  // 新闻资讯
  newsItem:{
    titlePartOne:'News',
    titlePartTwo:' Information',
    checkDetail:'Check Detail',
  },
  // 合作伙伴
  partnersItem:{
    titlePartOne:'Cooperative',
    titlePartTwo:' Partners',
  },
  // 关于我们
  aboutUsItem:{
    companyIdea:{
      title:'Company Philosophy',
      ideaOne:'Customer First (Service)',
      ideaTwo:'Teamwork (win-win)',
      ideaThree:'Honesty and trustworthiness (integrity)',
      ideaFour:'Embrace Change (Optimistic)',
    },
    courseList:{
      listOne:{
        title:'Company Established',
        content:'Our mission is to help domestic goods flow smoothly around the world, and to provide cross-border e-commerce enterprises with a fully visible, stable, and controllable global one-stop logistics solution. Our mission is to assist domestic goods flow smoothly around the world, and to provide cross-border e-commerce enterprises with a fully visible, stable, and controllable global one-stop logistics solution'
      },
      listTwo:{
        title:'Establish Yiwu office'
      },
      listThree:{
        title:'Fleetan Overseas Warehouse Landing in Saudi Arabia'
      },
      listFour:{
        title:'Shipping Online'
      },
      listFive:{
        title:'Fleetan has become one of the designated overseas warehouses for Amazon Seller Flex project cooperation'
      },
      listSix:{
        title:'Fleetan celebrates its second anniversary'
      },
      listSeven:{
        title:"Fleetan has officially become an authorized service provider for Amazon's self shipping VTR"
      },
      listEight:{
        title:'Open UAE dedicated line'
      },
      listNine:{
        title:'Fleetan South China Operation Center officially established'
      },
      listTen:{
        title:'Fleetan officially becomes an Amazon SPN service provider'
      }
    },
    contactInfo:{
      contactTitle:'Please contact us',
      contactSubTitle:'We will provide higher quality logistics solutions according to your needs',
      cnPartTitle:'China Headquarters',
      saPartTitle:'Saudi Arabia Branch',
      uaePartTitle:'United Arab Emirates Branch',
      name:'Name',
      email:'Email',
      phone:'Phone',
      address:'Address',
      formTitle:'Welcome to your message',
      contactType:'Contact',
      leaveWord:'Message',
      submit:'Submit',
      reset:'Reset'
    }
  }
}
export default en;



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js